module.exports = __webpack_public_path__ + "static/media/sportAvatar__smash.5458ca23.jpg";